import { render } from "./ConfigurationRestorePointTab.vue?vue&type=template&id=4e61d320&scoped=true"
import script from "./ConfigurationRestorePointTab.vue?vue&type=script&lang=js"
export * from "./ConfigurationRestorePointTab.vue?vue&type=script&lang=js"

import "./ConfigurationRestorePointTab.vue?vue&type=style&index=0&id=4e61d320&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e61d320"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
